import { Component } from '@angular/core';
import { WatchOrganizationService } from '../../../services/watch-organization.service';
import { OrganizationService } from '../../../services/organization.service';
import { Subscription, Observable } from 'rxjs';
import { IOrganization, IDrive } from '../../../interfaces/graph-types';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'organization-settings',
  template: require('./organization-settings.component.pug'),
  styles: [require('./organization-settings.component.css').toString()],
})
export class OrganizationSettingsComponent {
  bsModalRef: BsModalRef;

  org: IOrganization;

  sub: Subscription;
  emailReportDeliveryTest: string = null;
  webhookUrl: string = null;

  emailVerificationCredits: number = null;

  // -------------------------------------------------------------------
  constructor(
    private orgService: OrganizationService,
    private watch: WatchOrganizationService,
    private modalService: BsModalService,
  ) {}

  drives$: Observable<IDrive[]>;

  // -------------------------------------------------------------------
  ngOnInit(): void {
    let orgId = this.watch.organizationId().getValue();

    this.sub = this.orgService.settings(orgId).subscribe(res => {
      this.org = res;
      if (res) {
        this.emailReportDeliveryTest = res.emailReportDeliveryTest;
        this.webhookUrl = res.webhookUrl;
        this.emailVerificationCredits = res.emailVerificationCredits;
      }

      this.drives$ = this.orgService.drives(orgId);
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  changeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.orgService.setField(
      this.watch.organizationId().getValue(),
      data,
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
